import React from "react";
import { branch } from "baobab-react/higher-order";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ERROR_COLOR = "#b91c1c";
const WARNING_COLOR = "#b45309";

// Outline and property-panel badge for a node's activity-validation markers (actions/activityValidationActions.js).
// Subscribed to the marker store, so it repaints when a validation pass changes the node's findings even though
// the outline rows themselves only repaint when their node changes.
function ValidationBadge({ markers, entityId }) {
	const list = Array.isArray(markers) ? markers : [];
	if (list.length === 0) {
		return null;
	}
	const errors = list.filter((marker) => marker.type === "error").length;
	const warnings = list.length - errors;
	const parts = [];
	if (errors) {
		parts.push(`${errors} error${errors > 1 ? "s" : ""}`);
	}
	if (warnings) {
		parts.push(`${warnings} warning${warnings > 1 ? "s" : ""}`);
	}
	const stop = (e) => e.stopPropagation();
	const popover = (
		<Popover id={`validation-${entityId}`} title="Activity validation">
			<ul style={{ paddingLeft: 16, margin: 0, maxWidth: 380 }}>
				{list.map((marker, index) => (
					<li key={marker.key || index} style={{ color: marker.type === "error" ? ERROR_COLOR : WARNING_COLOR, marginBottom: 4, fontSize: 12 }}>{marker.text}</li>
				))}
			</ul>
		</Popover>
	);
	return (
		<OverlayTrigger trigger="click" rootClose placement="right" overlay={popover}>
			<div
				className="validation-info"
				role="button"
				tabIndex={0}
				title={`${parts.join(", ")} (click for details)`}
				aria-label={`Validation: ${parts.join(", ")}`}
				onClick={stop}
				onMouseDown={stop}
				onTouchStart={stop}
				style={{ display: "inline-flex", alignItems: "center", color: errors ? ERROR_COLOR : WARNING_COLOR, marginRight: 4, cursor: "pointer" }}
			>
				<FontAwesomeIcon icon={errors ? "exclamation-triangle" : "exclamation-circle"} />
			</div>
		</OverlayTrigger>
	);
}

export default branch((props) => ({
	markers: ["editActivityMetaData", "markers", props.entityId, "activityValidation"]
}), ValidationBadge);
